/* eslint-disable */
export interface FontFamilyData {
  value?: string;
}

const baseFontFamilyData: object = {};

export const FontFamilyData = {
  fromJSON(object: any): FontFamilyData {
    const message = { ...baseFontFamilyData } as FontFamilyData;
    message.value =
      object.value !== undefined && object.value !== null
        ? String(object.value)
        : undefined;
    return message;
  },

  toJSON(message: FontFamilyData): unknown {
    const obj: any = {};
    message.value !== undefined && (obj.value = message.value);
    return obj;
  },
};
